import { Component, OnInit, Injector, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { SupervisionComponentAPI } from "src/model/class/component classes/supervision-component-api";
import { GuiComponent, HAlign } from "src/model/enum/enumCustomInterface";
import { GenericBasicAggregateGUI } from "src/model/class/component classes/generic-basic-aggregate-gui";
import { CustomInterfacePlaceholderDirective } from "src/directive/custom-interface-placeholder.directive";

@Component({
    selector: "app-one-command-template",
    templateUrl: "./one-command-template.component.html",
    styleUrls: ["./one-command-template.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OneCommandTemplateComponent
  extends GenericBasicAggregateGUI
  implements OnInit
{
  private _componentListToRender: Array<SupervisionComponentAPI> = null;
  private _forceBold: boolean = false;

  @ViewChild(CustomInterfacePlaceholderDirective, { static: true })
  componentHost: CustomInterfacePlaceholderDirective;

  constructor(_injector: Injector) {
    super(_injector);
  }

  ngOnInit() {
    this._componentListToRender = this.aggregate.listComponent;

    /** When some address label releated with other kind of button, it filter label component to avoid to render */
    if (this.aggregate.listComponent.length === 2) {
      this.searchLabelNameComponent();

      this._componentListToRender = this.aggregate.listComponent.filter(
        (component: SupervisionComponentAPI) =>
          component.code !== GuiComponent.LABEL
      );
    } else if (
      this.aggregate.listComponent.findIndex(
        (component: SupervisionComponentAPI) =>
          component.code === GuiComponent.LABEL
      ) >= 0
    ) {
      this._forceBold = true;
    }
  }

  ngAfterContentInit() {
    this.componentHost.drawCustomInterfaceComponents(
      this._componentListToRender,
      false,
      this.hAlign.RIGHT,
      this._forceBold
    );
  }
}
